module.exports = __webpack_public_path__ + "static/media/nauka-pisania-na-klawiaturze-inf1-2.421a827d.png";